import { gql } from "@apollo/client";

export const getUnReadNotificationMessages = gql`
  query GetUnReadNotificationMessages {
    getUnReadNotificationMessages {
      offer_detail {
        policy_number
        insured_by
        period_of_insurance_from
        period_of_insurance_to
      }
      thread_notification {
        id
        status
      }
      insurer {
        insurer_company_name
        insurer_id
      }
      offer_status
      payment_status
      classofbusiness {
        business_name
      }
    }
  }
`;

export const getKavaNotifications = gql`
query FetchUnreadTransactionThreadMessagesForBroker {
  fetchUnreadTransactionThreadMessagesForBroker {
    status
    receiver_type
    offer {
      offer_id
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      offer_status
      payment_status
      claim_status
      expiry_status
      created_at
      updated_at
      offer_from
      place_it_id
      offer_detail {
        offer_detail_id
        offersoffer_id
        policy_number
        insured_by
        period_of_insurance_from
        period_of_insurance_to
        currency
        offer_comment
        offer_details
        updated_at
      }
      thread_notification {
        id
        status
      }
      classofbusiness {
        class_of_business_id
        business_name
        business_details
        business_category
        single_total_overview
        single_total_offers
        created_at
      }
      insurer {
        insurer_id
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_abbrv
      }
    }
  }
}

`;